import React, { MutableRefObject } from 'react';
import { useNavigate, useLocation } from 'react-router';
import * as CONSTANT from '../../../constants';
import { createPayloadForSelectedSingleItemModifier } from '../../../helpers/customizedItem/customizedItem.helper';
import { IOrder } from '../../../models/order.model';
import { itemBuckets } from '../../../priceCalculation/buckets';
import { makeAnItemToTry2Combo } from '../../../redux/slices/itemCustomizationSlice';
import { useAppDispatch } from '../../../redux/store/store';
import _clonedeep from 'lodash.clonedeep'
import useCheckMobileScreen from '../../../hooks/useCheckMobileScreen';
import { useIsDesignV2 } from '../../../hooks/useIsDesignV2';

interface IMakeItTryTwoCombo {
  handleSyncIngredients: (item) => void;
  item: any;
  order: IOrder;
  getOrderButtonState: (type: string) => {
    status: boolean,
    missingGroupIndex?:number,
  };
  handleIngredientSelection: (data: any, id?: number) => void;
  showCustomization: boolean;
  showCustomizedOptions: boolean;
  stickyAddToCartStyle:boolean;
  isNavigatingToCombo?:MutableRefObject<boolean>;
  handleMakeItComboValidation: () => boolean;
}

const MakeItTryTwoCombo: React.FC<IMakeItTryTwoCombo> = (props) => {
  const { item, order, getOrderButtonState, handleIngredientSelection, showCustomizedOptions, showCustomization, stickyAddToCartStyle, isNavigatingToCombo, handleMakeItComboValidation } = props;

  const history = useNavigate();
  const dispatch = useAppDispatch();

  const location = useLocation();

  const isThisMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2();
  
  const addCategoryId = (currentOrder) => {
    currentOrder.modifiers[0].category_id = item?.category_id;
    return currentOrder;
  };

  const addSelectedIngredients = () => {
    if (!(showCustomizedOptions || showCustomization)) {
      for (let index = 0; index < item?.is_selected?.length; index++) {
        handleIngredientSelection(
        createPayloadForSelectedSingleItemModifier(item?.is_selected[index]),
          CONSTANT.SINGLE_ITEM_SELECTED_SECTION
        );
      }
    }
  };
  const handleMakeItTry2ComboClick = (e) => {
    e.stopPropagation();
    
    // Use the validation handler which handles scrolling to missing sections
    const validationPassed = handleMakeItComboValidation();
    if (!validationPassed) {
      return; // Validation failed, scrolling/highlighting handled by validation function
    }
    
    // Validation passed, proceed with combo navigation
    if(isNavigatingToCombo) isNavigatingToCombo.current = true;
    // addSelectedIngredients();
    const finalOrder = addCategoryId(_clonedeep(order));
    dispatch(
      makeAnItemToTry2Combo({
        bucket: _clonedeep(itemBuckets.getBuckets()),
        item,
        order: finalOrder,
      })
    );
    history(`${CONSTANT.ROUTE_MENU}/${CONSTANT.TRY_2_COMBO_CAPITALIZE}`);
  };

  const buttonState = () => {
    if (item?.half_brink_item_id) {
      return order?.size !== CONSTANT.HALF_SIZE.upper_case || getOrderButtonState(CONSTANT.MAKE_IT_A_TRY_2_COMBO).status;
    } else {
      return getOrderButtonState(CONSTANT.MAKE_IT_A_TRY_2_COMBO).status
    }
  }
  return (
    <>
      {
        order?.size == CONSTANT.HALF_SIZE.upper_case || !item.half_brink_item_id ? <button
          type="button"
          className={`btn btn-large outline w-100 mx-auto ${stickyAddToCartStyle ? 'mb-0 sticky-add-to-cart-py' : 'mb-3'} ${isDesignV2 && "f-sm-s16 make-it-try-to-combov2" }`}
          onClick={handleMakeItTry2ComboClick}
          // disabled={buttonState()}
        >
          make it a try 2 combo
        </button> : null
      }
    </>
  );
};

export default MakeItTryTwoCombo;